module.exports = __webpack_public_path__ + "static/banner-2360b1974e9687cd8a98f755e2350eeb.jpg";